import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.126 3.222a.38.38 0 0 1 .496.056l.049.064 2.798 4.504 4.376-.894a.75.75 0 0 1 .744 1.191l-2.727 3.552-.002.001 2.538 4.086a.385.385 0 0 1-.134.542l-.338.175a7.7 7.7 0 0 1-4.452.711l.284 2.075H12a2.75 2.75 0 0 1 2.75 2.75 1.15 1.15 0 0 1-1.15 1.15H4.2a1.15 1.15 0 0 1-1.15-1.15 2.75 2.75 0 0 1 2.75-2.75h.241l.642-4.685a8 8 0 0 1-.708-.964l-.195-.332A7.72 7.72 0 0 1 8.126 3.222M5.8 20.786a1.25 1.25 0 0 0-1.199.9H13.2a1.25 1.25 0 0 0-1.199-.9zm1.756-1.5h2.689l-.338-2.464a7.7 7.7 0 0 1-1.88-.988zm.518-14.064a6.225 6.225 0 0 0 6.374 10.263zm4.238 3.981.703 1.133 1.161-1.513z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.561 2.741a.75.75 0 0 1 .918-.53 6.1 6.1 0 0 1 4.314 7.471.75.75 0 1 1-1.449-.388 4.6 4.6 0 0 0-3.252-5.634.75.75 0 0 1-.53-.919zm-.5 2.355a.75.75 0 0 1 .919-.53 3.57 3.57 0 0 1 2.522 4.369.75.75 0 1 1-1.449-.388 2.07 2.07 0 0 0-1.462-2.532.75.75 0 0 1-.53-.919"
}));
const ForwardRef = forwardRef(SvgComponent);
export const SatelliteDishIcon = ForwardRef;